import { useFilters } from "@website/widget/filter";
import { useVillaFiltersSchema } from "./index.constant";

export const useVillagesFilter = (
  hotelListResultsCount: number,
  isListingDataFetched: boolean
) => {
  const { filtersSchema, chipsFiltersSchema } =
    useVillaFiltersSchema(isListingDataFetched);

  const { clearFilters } = useFilters({ schema: filtersSchema });

  return {
    clearAllFilters: clearFilters,
    filtersSchema,
    chipsFiltersSchema,
    hotelListResultsCount
  };
};
